/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_category_settings__select_all = /** @type {(inputs: {}) => string} */ () => {
	return `Alles anzeigen`
};

const en_poi_category_settings__select_all = /** @type {(inputs: {}) => string} */ () => {
	return `Show all`
};

const es_poi_category_settings__select_all = /** @type {(inputs: {}) => string} */ () => {
	return `Mostrar todo`
};

const fr_poi_category_settings__select_all = /** @type {(inputs: {}) => string} */ () => {
	return `Tout afficher`
};

const it_poi_category_settings__select_all = /** @type {(inputs: {}) => string} */ () => {
	return `Visualizza tutto`
};

const nl_poi_category_settings__select_all = /** @type {(inputs: {}) => string} */ () => {
	return `Alles weergeven`
};

const pt_poi_category_settings__select_all = /** @type {(inputs: {}) => string} */ () => {
	return `Mostrar tudo`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__select_all = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_category_settings__select_all(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_category_settings__select_all", locale)
	if (locale === "de") return de_poi_category_settings__select_all(inputs)
	if (locale === "en") return en_poi_category_settings__select_all(inputs)
	if (locale === "es") return es_poi_category_settings__select_all(inputs)
	if (locale === "fr") return fr_poi_category_settings__select_all(inputs)
	if (locale === "it") return it_poi_category_settings__select_all(inputs)
	if (locale === "nl") return nl_poi_category_settings__select_all(inputs)
	return pt_poi_category_settings__select_all(inputs)
};